////////////////////////////////////////////////////////////////////////////////
//                                                                            //
//  IRONSIDE - Public Website GUI                                             //
//                                                                            //
//  Version: 1.0.1                                                            //
//  Summary: Date/number formatting helpers (luxon)                          //
//                                                                            //
////////////////////////////////////////////////////////////////////////////////

import { DateTime } from 'luxon';

// en-AU throughout — DD Month YYYY is the house date format (root CLAUDE.md).
const LOCALE = 'en-AU';

/** ISO 8601 string -> "9 August 2026". Returns `fallback` ('—' by default) on an
 * unparseable or absent input rather than throwing — this is UI-facing formatting,
 * not the content build (which fails loudly on a bad date; see scripts/build-content.ts). */
export function formatDate (iso: string | null | undefined, fallback = '—'): string {
  if (!iso) return fallback;
  const dt = DateTime.fromISO(iso, { zone: 'Australia/Melbourne' });
  return dt.isValid ? dt.setLocale(LOCALE).toFormat('d MMMM yyyy') : fallback;
}

/** ISO 8601 string -> "9 Aug 2026" — compact form for listing cards. */
export function formatDateShort (iso: string | null | undefined, fallback = '—'): string {
  if (!iso) return fallback;
  const dt = DateTime.fromISO(iso, { zone: 'Australia/Melbourne' });
  return dt.isValid ? dt.setLocale(LOCALE).toFormat('d MMM yyyy') : fallback;
}

/** ISO 8601 string -> "9 August 2026, 2:30 pm" — used where the time, not just the
 * date, is the point (e.g. a session expiry on the admin dashboard). */
export function formatDateTime (iso: string | null | undefined, fallback = '—'): string {
  if (!iso) return fallback;
  const dt = DateTime.fromISO(iso, { zone: 'Australia/Melbourne' });
  return dt.isValid ? dt.setLocale(LOCALE).toFormat('d MMMM yyyy, h:mm a') : fallback;
}
